import { Routes } from '@angular/router';
import { RecoverPasswordComponent } from '@app/+login/views/recover-password/recover-password.component';
import { EntryComponent } from '@app/+login/views/entry/entry.component';
import { HybridLoginComponent } from '@app/+login/deprecated-hybrid/views/hybrid-login/hybrid-login.component';
import { OtpLoginConfirmationComponent } from '@app/+login/deprecated-hybrid/views/otp-login-confirmation/login-confirmation.component';
import { HybridSignupComponent } from '@app/+login/deprecated-hybrid/views/hybrid-signup/hybrid-signup.component';
import { MagicLinkLoginConfirmationComponent } from '@app/+login/deprecated-hybrid/views/magic-link-login-confirmation/magic-link-login-confirmation.component';
import { OtpSignupConfirmationComponent } from '@app/+login/deprecated-hybrid/views/otp-signup-confirmation/otp-signup-confirmation.component';
import { MagicLinkSignupConfirmationComponent } from '@app/+login/deprecated-hybrid/views/magic-link-signup-confirmation/magic-link-signup-confirmation.component';
import { LoginPhoneConfirmationComponent } from '@app/+login/deprecated-hybrid/views/phone-confirmation/login-phone-confirmation/login-phone-confirmation.component';
import { SignupPhoneConfirmationComponent } from '@app/+login/deprecated-hybrid/views/phone-confirmation/signup-phone-confirmation/signup-phone-confirmation.component';
import { ConsentsDataResolver } from '@app/+login/deprecated-hybrid/resolvers/consents-data.resolver';
import { appRedirectGuard } from '@app/+login/guards/app-redirect.guard';
import { HYBRID_AUTH_PATH, HYBRID_REGISTER_PATH } from '@app/+login/consts';
import {
  canUseDeprecatedHybridLoginGuard,
  canUseNewOidcLoginObservableCallback,
} from '@app/+login/tmp-oidc-migration/tmp-login-guards';
import { AuthCallbackComponent } from '@app/+login/oidc-hybrid/views/auth-callback/auth-callback.component';
import { OidcLoginComponent } from '@app/+login/oidc-hybrid/views/oidc-login/oidc-login.component';
import { loginGuard } from '@app/+login/guards/login.guard';
import { authCallbackGuard } from '@app/+login/guards/auth-callback.guard';

const DEPRECATED_HYBRID_ROUTES: Routes = [
  {
    path: '',
    component: HybridLoginComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
  {
    path: 'phone_confirmation',
    component: LoginPhoneConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
  {
    path: HYBRID_REGISTER_PATH,
    component: HybridSignupComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
  {
    path: 'register/phone_confirmation',
    component: SignupPhoneConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
  {
    path: 'register/confirmation',
    component: OtpSignupConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
    resolve: {
      consentsData: ConsentsDataResolver,
    },
  },
  {
    path: 'login',
    component: MagicLinkLoginConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
  {
    path: 'signup',
    component: MagicLinkSignupConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
    resolve: {
      consentsData: ConsentsDataResolver,
    },
  },
  {
    path: HYBRID_AUTH_PATH,
    component: OtpLoginConfirmationComponent,
    canMatch: [
      canUseDeprecatedHybridLoginGuard,
    ],
  },
];
const OIDC_HYBRID_ROUTES: Routes = [
  {
    path: '',
    component: OidcLoginComponent,
    canMatch: [
      canUseNewOidcLoginObservableCallback,
    ],
    canActivate: [
      loginGuard,
    ],
  },
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
    canMatch: [
      canUseNewOidcLoginObservableCallback,
    ],
    canActivate: [
      authCallbackGuard,
    ],
  },
];
export const LOGIN_ROUTES: Routes = [
  {
    path: '',
    component: EntryComponent,
    children: [
      ...DEPRECATED_HYBRID_ROUTES,
      ...OIDC_HYBRID_ROUTES,
    ],
    canActivate: [
      appRedirectGuard,
    ],
  },
  {
    path: 'recover_password',
    component: RecoverPasswordComponent,
  },
  {
    path: 'set_password',
    component: RecoverPasswordComponent,
  },
];
